import React from "react";
import "./contactus.css";
const Contact = () => {
  return (
    <div className="contact-page">
      <h2 className="contact-heading">Get in Touch</h2>
      <p className="contact-subtext">
  We'd love to discuss your upcoming project or answer any questions you have. 
  Reach out to us through the contact form or the details below.</p>
      {/* Bottom section: Map + Form */}
      <div className="contact-bottom">
        <div className="contact-map">
          <iframe
            title="office-location"
            src= "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d31093.456960230975!2d80.14364636129164!3d13.055894635086345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sSF%20NO%20120%20%2F1%20NO%202%2C%20Ganapathy%20Nagar%20Main%20road%2C%20Vanagaram%2C%20Chennai%2C%20Tamil%20Nadu%20600095!5e0!3m2!1sen!2sin!4v1747563339000!5m2!1sen!2sin"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <form
        action="https://formspree.io/f/mdkgrjrv"
        method="POST"
        className="footer-form"
      >
        <div className="row g-2">
          <div className="col-md-6">
            <input type="text" name="firstName" placeholder="First Name" required />
          </div>
          <div className="col-md-6">
            <input type="text" name="lastName" placeholder="Last Name" required />
          </div>
        </div>
        <input type="tel" name="phone" placeholder="Phone Number" className="mt-2" required />
        <input type="email" name="email" placeholder="Email Address" className="mt-2" required />
        <textarea name="message" placeholder="Your Message" rows="3" className="mt-2" required></textarea>
        <button type="submit" className="btn btn-primary mt-3">Submit</button>
      </form>
        {/* <div className="contact-form">
          <form>
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email" />
            <input type="tel" placeholder="Phone Number" />
            <textarea placeholder="Your Message"></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div> */}
      </div>
      <div className="contact-top">
        <div className="contact-address">
          <h1>Head Office</h1>
          <p>S. No 19, Govindan Street, Ayyavoo Colony, Aminjikarai, Chennai - 600029</p>
          <p><strong>✆</strong> +91-9676764491</p>
          <p><strong>📩</strong> info@oceancruise.in</p>
          <h1>Branch</h1>
          <p>Lakdikapul, Telangana-500004 Hyderabad.</p>
          <p><strong>✆</strong> +91-9676764491</p>
          
        </div>
      </div>
    </div>
  );
};

export default Contact;